import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { MerchantProvider } from './contexts/MerchantContext';
import { ToastProvider } from './contexts/ToastContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import Layout from './components/Layout';
import Home from './pages/Home';
import Categories from './pages/Categories';
import Establishment from './pages/Establishment';
import MapPage from './pages/MapPage';
import ErrorBoundary from './components/ErrorBoundary';

// Placeholder pages (temporary)
import Benefits from './pages/Benefits';
import Profile from './pages/Profile';

// New pages
import Notifications from './pages/Notifications';
import MerchantPortal from './pages/MerchantPortal';
import { MerchantRouteGuard } from './components/MerchantRouteGuard';

// Auth pages
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import MerchantLogin from './pages/MerchantLogin';
import MerchantFirstAccess from './pages/MerchantFirstAccess';

import Roteiro from './pages/Roteiro';
import GuiaIa from './pages/guia_ia';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ToastProvider>
          <MerchantProvider>
            <Router>
              <div className="container">
                <Routes>
                  {/* Auth routes - outside Layout */}
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/merchant-login" element={<MerchantLogin />} />

                  {/* Portal do parceiro: guard consulta mustChangePassword no banco */}
                  <Route path="/merchant" element={<MerchantRouteGuard />}>
                    <Route index element={<MerchantPortal />} />
                    <Route path="first-access" element={<MerchantFirstAccess />} />
                  </Route>

                  {/* Main app routes - with Layout */}
                  <Route element={<Layout />}>
                    {/* Public routes */}
                    <Route path="/" element={<Home />} />
                    <Route path="/categories" element={<Categories />} />
                    <Route path="/establishment/:id" element={<Establishment />} />
                    <Route path="/roteiro/:id" element={<Roteiro />} />
                    <Route path="/assistente" element={<GuiaIa />} />
                    <Route path="/map" element={<MapPage />} />

                    {/* Protected routes */}
                    <Route path="/benefits" element={
                      <ProtectedRoute><Benefits /></ProtectedRoute>
                    } />
                    <Route path="/profile" element={
                      <ProtectedRoute><Profile /></ProtectedRoute>
                    } />
                    <Route path="/notifications" element={
                      <ProtectedRoute><Notifications /></ProtectedRoute>
                    } />
                  </Route>
                </Routes>
              </div>
            </Router>
          </MerchantProvider>
        </ToastProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
